import { Dropdown, InputLine } from '@quero-delivery/quero-components-web';
import { Controller, useFormContext } from 'react-hook-form';
import styles from './cnh-data-form.module.scss';
import type { DeliverymanFormType } from '../../types';
import { CATEGORIAS_CNH, VEHICLE_TYPES_OPTIONS } from '../../constants';

function CnhDataForm() {
  const {
    control,
    formState: { errors },
  } = useFormContext<DeliverymanFormType>();

  return (
    <div className={styles.container}>
      <span className={styles.subtitleForm}>Sobre CNH</span>

      <div className={styles.form}>
        <div className={styles.twoLines}>
          <div className={styles.lineLeft}>
            <Controller
              control={control}
              name="cnh.numeroCNH"
              render={({ field: { onChange, value } }) => (
                <InputLine
                  label="CNH - Número"
                  errorMessage={errors.cnh?.numeroCNH?.message}
                  value={value}
                  onChange={event => onChange(event.target.value)}
                />
              )}
            />
          </div>
          <div className={styles.lineRight}>
            <Controller
              control={control}
              name="cnh.categoriaCNH"
              render={({ field: { onChange, value } }) => (
                <Dropdown
                  clearable
                  label="CNH - Categoria"
                  placeholder="Selecione a categoria"
                  options={CATEGORIAS_CNH}
                  errorMessage={errors.cnh?.categoriaCNH?.message}
                  value={value}
                  onChange={(event, data) => onChange(data.value)}
                />
              )}
            />
          </div>
        </div>
        <div className={styles.twoLines}>
          <div className={styles.lineLeft}>
            <Controller
              name="cnh.dataEmissaoCNH"
              control={control}
              render={({ field: { onChange, value } }) => (
                <InputLine
                  label="CNH - Data de Emissao"
                  onChange={event => onChange(event.target.value)}
                  value={value}
                  errorMessage={errors.cnh?.dataEmissaoCNH?.message}
                  type="date"
                />
              )}
            />
          </div>
          <div className={styles.lineRight}>
            <Controller
              name="cnh.validadeCNH"
              control={control}
              render={({ field: { onChange, value } }) => (
                <InputLine
                  label="CNH - Data de Validade"
                  onChange={event => onChange(event.target.value)}
                  value={value}
                  errorMessage={errors.cnh?.validadeCNH?.message}
                  type="date"
                />
              )}
            />
          </div>
        </div>
        <Controller
          control={control}
          name="tipoVeiculo"
          render={({ field: { onChange, value } }) => (
            <Dropdown
              clearable
              label="Tipo de veiculo"
              placeholder="Selecione o tipo do veiculo"
              options={VEHICLE_TYPES_OPTIONS}
              errorMessage={errors.tipoVeiculo?.message}
              value={value}
              onChange={(event, data) => onChange(data.value)}
            />
          )}
        />
      </div>
    </div>
  );
}

export { CnhDataForm };
